import React, { useState, useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { performLogout } from '@/utils/logoutUtils';

/**
 * SessionWarning - Shows warning when session is about to expire
 */
function SessionWarning() {
  const { 
    showSessionWarning, 
    extendSession, 
    dismissSessionWarning 
  } = useAuthStore();
  
  const [countdown, setCountdown] = useState(300); // 5 minutes in seconds

  useEffect(() => {
    if (!showSessionWarning) {
      setCountdown(300);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          // Auto logout when countdown reaches 0
          performLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showSessionWarning]);

  if (!showSessionWarning) {
    return null;
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handleLogoutNow = () => {
    performLogout();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <div className="flex items-center mb-4">
          <div className="text-yellow-500 text-2xl mr-3">⚠️</div>
          <h3 className="text-lg font-semibold text-gray-900">
            Session Expiring Soon
          </h3>
        </div>
        
        <p className="text-gray-600 mb-4">
          Your session will expire in <strong className="text-red-600">{formatTime(countdown)}</strong>.
          You will be automatically logged out for security reasons.
        </p>
        
        <div className="flex space-x-3">
          <button
            onClick={extendSession}
            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Extend Session
          </button>
          
          <button
            onClick={handleLogoutNow}
            className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors"
          >
            Logout Now
          </button>
        </div>
        
        <button
          onClick={dismissSessionWarning}
          className="w-full mt-2 text-sm text-gray-500 hover:text-gray-700"
        >
          Dismiss (will still auto-logout)
        </button>
      </div>
    </div>
  );
}

export default SessionWarning;
